import React, { Dispatch } from 'react';
import { ICreateForumProps, ICreateForumData } from '../../models/components/create-forum';
import { Modal } from 'reactstrap';
import { IState } from '../../models/components/lesson-upcoming-activity';
import { IAction, IAppState } from '../../models/action/core';
import { getValidation } from '../../models/validations/forum-add-validation';
import { Quil } from '../../components/input/quil/main';
import { connect } from 'react-redux';
import Input from '../../components/input/text/input-formik';
import Translator from '../../core/i18n';
import Loading from '../loading/loading';
import { Notification } from '../../components/notification/main';
import { Formik, FormikActions, FormikProps } from 'formik';
import { Log } from 'ng2-logger';
import { addForum, getForumThreadById, setForumThreadById } from '../../store/actions/forum';
import InputFormik from '../../components/input/text/input';

const T = Translator.create();
const _logger = Log.create('CreateOrEditForum.tsx');

class CreateForum extends React.Component<ICreateForumProps> {

    public onClose = () => {
        this.props.isClose();
    }

    public onSubmit = (values: ICreateForumData, formikActions: FormikActions<any>) => {
        values.isCommon = true;
        this.props.dispatch(addForum(values, 'createForumLoading', 'get', this.callBackFunction));
    }

    public callBackFunction = (value: boolean) => {
        if (value) {
            this.onClose();
        }
    };

    public componentWillUpdate = (nextProps: ICreateForumProps) => {
        if (nextProps.forumThreadId && nextProps.forumThreadId !== this.props.forumThreadId) {
            this.props.dispatch(getForumThreadById(nextProps.forumThreadId, 'createForumLoading', 'get'));
        }
    }

    public async beforeClickForm(ikParameter: FormikProps<ICreateForumData>) {
        const returnValue = await ikParameter
            .validateForm()
            .then((returnData: any) => {
                let errorCount = 0;

                Object.keys(returnData).forEach(key => {
                    Notification.setNotification(
                        'error',
                        T.t('videoactivity_' + key) + ' - ' + returnData[key],
                        'topRight'
                    );
                    errorCount++;
                });
                if (errorCount === 0) {
                    if (this.props.forumThreadId) {
                        ikParameter.values.forumThreadId = this.props.forumThreadId;
                    }
                    ikParameter.submitForm();
                }
            });

        return returnValue;
    }

    render() {
        const initialValues = { ...this.props.createforumData! };
        return (
            <Modal isOpen={this.props.isOpen} >
                {(this.props.forumThreadId! && initialValues.forumThreadId) || !this.props.forumThreadId ? (
                    <Formik
                        initialValues={initialValues}
                        validationSchema={getValidation}
                        onSubmit={this.onSubmit}
                        enableReinitialize={true}
                        // tslint:disable-next-line
                        render={props => (
                            <form onSubmit={props.handleSubmit}>
                                <div className="assignment-feedback bulk-grade" id="add-forum-modal">
                                    <Loading spinnerId={'createForumLoading'} />
                                    <div>
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h6 className="modal-title d-inline-flex align-items-center" id="exampleModalLabel">
                                                    {T.t('r_gen_froum_create')}
                                                </h6>
                                                <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                {/* <div className="row">
                                                    <div className="col-sm-6">
                                                        <div className="radio-tabs tick-radio position-relative">
                                                            <input type="radio" name={'isCommon'} onChange={props.setFieldValue.bind(this, 'isCommon', true)} checked={props.values.isCommon ? true : false} id="r-genel" className="form-radio" />
                                                            <label htmlFor="r-genel" >{T.t('r_gen_general')}</label>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="clear m-t-15" />
                                                <h5>{T.t('r_add_forum_subject')}</h5>
                                                <div className="form-input form-group note-pad mb-0" style={{ paddingBottom: '15px', minHeight: 0 }}>
                                                    <InputFormik
                                                        value={props.values.subject}
                                                        errors={props.errors.subject}
                                                        touched={props.touched.subject}
                                                        handleChange={props.handleChange}
                                                        handleBlur={props.handleBlur}
                                                        required={true}
                                                        type={'text'}
                                                        name={'subject'} />
                                                    <span className="highlight" />
                                                    <span className="bar" />
                                                </div>
                                                <h5 className="mt-4 mb-2">{T.t('r_add_forum_moderate')}</h5>
                                                <div className="col-sm-2 tick-radio text-md-right mt-sm-0 mt-3" style={{ paddingLeft: 0 }}>
                                                    <input name={'isModerated'} type="checkbox" onChange={props.handleChange} checked={props.values.isModerated} value="1" id="check-onDownload" className="form-radio" />
                                                    <label htmlFor="check-onDownload">{props.values.isModerated ? T.t('r_yes') : T.t('r_no')}</label>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-gray-outline" onClick={this.onClose} data-dismiss="modal">{T.t('r_gen_cancel')}</button>
                                                <button type="button" onClick={() => this.beforeClickForm(props)} className="btn btn-gray">{T.t('r_gen_save')}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                ) : (
                        ''
                    )}
            </Modal >
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICreateForumProps) => {
    if (!state) {
        return ownProps;
    }
    const createForumData = state.forum.createAndEditData;
    const newProps: ICreateForumProps = Object.assign({}, ownProps, {
        createforumData: createForumData
    });

    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.forum.forumMessageThreadId === prev.forum.forumMessageThreadId &&
        next.forum.createAndEditData === prev.forum.createAndEditData;
    return ret;
};

const CCreateForum = connect(mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual,
    }
)(CreateForum);

export default CCreateForum;